export default __webpack_public_path__ + "static/media/photogallery-03.39d74b91.webp";